import { render, staticRenderFns } from "./SectionsComponent.vue?vue&type=template&id=f63d269a&scoped=true"
import script from "./SectionsComponent.vue?vue&type=script&lang=js"
export * from "./SectionsComponent.vue?vue&type=script&lang=js"
import style0 from "./SectionsComponent.vue?vue&type=style&index=0&id=f63d269a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63d269a",
  null
  
)

export default component.exports